import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function IntegerProperties({ question }) {
  return <QuestionLabel question={question} />
}